export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f069a48cb046d9f884c7c5c40645704a1cdc52d95&name=fetchTypeahead!'